import {Routes, Route, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Home from './Home';
import Sobre from './Sobre';
/* import Contato from './Contato'; */
import Fontes from './Fontes';

export default function Rotas(){
	const location = useLocation();
	return(
		<TransitionGroup>
        <CSSTransition key={location.key} classNames='container' timeout={500}>
          <Routes location={location}>
            <Route path="/" element={<Home/>} />
            <Route path="/Sobre" element={<Sobre/>}/>
            {/* <Route path="/Contato" element={<Contato/>}/> */}
            <Route path="/Fontes" element={<Fontes/>}/>
          </Routes>
        </CSSTransition>
      </TransitionGroup>
	)
}

